import type { CardViewModel } from '../types/Cards.types';

interface CardLike {
  id?: string | null;
  status?: string | null;
  active?: boolean | null;
  referenceId?: string | null;
  processor?: string | null;
  lastFour?: string | null;
  expDate?: string | null;
  physicalActivatedAt?: string | null;
  blockedReason?: string | null;
  dateOpened?: string | null;
  insertedAt?: string | null;
  user?: { id?: string | null; firstName?: string | null; lastName?: string | null } | null;
}

export const toCardViewModel = (card: CardLike): CardViewModel => ({
  id: card.id ?? '',
  status: card.status ?? null,
  active: card.active ?? null,
  referenceId: card.referenceId ?? null,
  processor: card.processor ?? null,
  lastFour: card.lastFour ?? null,
  expDate: card.expDate ?? null,
  physicalActivatedAt: card.physicalActivatedAt ?? null,
  blockedReason: card.blockedReason ?? null,
  dateOpened: card.dateOpened ?? null,
  insertedAt: card.insertedAt ?? null,
  user: card.user?.id
    ? { id: card.user.id, name: [card.user.firstName, card.user.lastName].filter(Boolean).join(' ') || null }
    : null,
});
